import axios from "axios";
import { store } from "../globalstate/GlobalState";
import { customAlphabet } from "nanoid";
import { URL } from "../../constant/url";

const nanoid = customAlphabet("0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ", 6);


export const getOrCreateBillId = () => {
  let billId = localStorage.getItem("billId");
  if (!billId) {
    billId = nanoid();
    localStorage.setItem("billId", billId);
  }
  return billId;
};


const formatItems = (items, selectedSizes = {}) => {
  const arrayItems = Array.isArray(items) ? items : [items];

  return arrayItems.map((item) => {
    let formatted = {
      ...item,
      size: selectedSizes[item.name] || item.size || "M",
    };

    if (item.type === "Topping") {
      const { Toppings, Note, size, ...rest } = formatted;
      formatted = rest;
    }

    return formatted;
  });
};


const handleMessage = (actionType, item, message) => {
  if (!message) return;

  const { name } = Array.isArray(item) ? item[0] : item;

  const messages = {
    "delete-item": `${name} deleted successfully!`,
    "add-item": `${name} added successfully!`,
    "save-bill": "Bill saved successfully!",
    "solved-bill": "Bill completed successfully!",
  };

  const msg = messages[actionType];
  if (msg) message.success(msg);
};


export const sendBillAction = async (actionType,item,selectedSizes = {},message = null,Bill_Name = "",paymentMethod='unpaid') => {
  try {
    const billId = getOrCreateBillId();
    store.setState({ id: billId });


    // console.log("checking payment method",paymentMethod)

    const billData = {
      bill: {
        Bill_ID: billId,
        Location: localStorage.getItem("selectedLocation") || "default_location",
        Cashier_Name: localStorage.getItem("cashier"),
        Action_Type: actionType,
        Status: "pending",
        paymentMethod: paymentMethod,
        Bill_Name,
        Item_Selected: formatItems(item, selectedSizes),
      },
    };

    await axios.post(`${URL}/api/process-bill`, billData);

    handleMessage(actionType, item, message);

    if (actionType === "save-bill") {
      localStorage.removeItem("billId");
    }
  } catch (error) {
    console.error(`❌ Error sending ${actionType}:`, error);
    message?.error("Failed to send action!");
  }
};


export const SaveBill = async (billId, message = null) => {
  try {
    await axios.post(`${URL}/api/save-bill`, { billId });
    localStorage.removeItem("billId");
    message?.success("Bill saved successfully!");
  } catch (error) {
    console.error(`❌ Error saving bill:`, error);
    message?.error("Failed to save bill!");
  }
};
